module.exports = __webpack_public_path__ + "static/media/changelog-light.b4452b9c.jpg";